import { getEnv } from '@config';
import { axiosInstance } from '@services/base-service';

const { orgId } = getEnv();
const loginUri = '/api/login-merchant/v1/bff/merchant';

export const login = ({ email, password, sessionId }) =>
  axiosInstance
    .getInstance()
    .post(
      `${loginUri}/merchant`,
      { payload: { email, password, org_id: orgId, session_id: sessionId } },
      { hasAuthorization: false }
    );

export const logout = ({ fingerprint }) =>
  axiosInstance.getInstance().delete(`${loginUri}/merchant/session/${fingerprint}`, {
    headers: {
      'x-flow-service': 'MERCHANT',
    },
    hasAuthorization: false,
  });

export const sendResetPasswordEmail = ({ email }) =>
  axiosInstance
    .getInstance()
    .post(
      `${loginUri}/merchant/change-password`,
      { payload: { email } },
      { hasAuthorization: false }
    );

export const resetPassword = ({ token, password }) =>
  axiosInstance
    .getInstance()
    .post(
      `${loginUri}/merchant/reset/${token}`,
      { payload: { password } },
      { hasAuthorization: false }
    );

export const validateTokenResetPassword = ({ token }) =>
  axiosInstance
    .getInstance()
    .post(`${loginUri}/merchant/reset/validate/${token}`, {}, { hasAuthorization: false });

export const tyc = ({ merchantId, version }) =>
  axiosInstance
    .getInstance()
    .post(
      `${loginUri}/merchant/tyc/${merchantId}`,
      { payload: { tyc: { id: 'MERCHANT', accepted: true, version } } },
      { hasAuthorization: false }
    );
